export const NOTIFICATION_TYPES = {
  PATIENT_SETUP_COMPLETED: 'patient-setup-completed',
  RUSH_CASE: 'rush-case',
  UPDATED_NOTIFICATION: 'updated-notification',
  CASE_OFF_HOLD_ADMIN: 'case-off-hold-admin',
  PATIENT_DELETED: 'patient-deleted'
};

export const NOTIFICATION_ALERTS = [
    NOTIFICATION_TYPES.RUSH_CASE,
    NOTIFICATION_TYPES.CASE_OFF_HOLD_ADMIN,
    NOTIFICATION_TYPES.PATIENT_DELETED
];
